import { createFileRoute } from "@tanstack/react-router";
import { seo, seoLinks } from "~/utils/seo";
import { CTABannerDark } from "~/components/blocks/CTABannerDark";
import { LatestCardsDark } from "~/components/blocks/LatestCardsDark";
import { loadLatestCards } from "~/utils/content-fns";

export const Route = createFileRoute("/thanks-for-your-interest")({
  loader: async () => {
    const cards = await loadLatestCards();
    return { cards };
  },
  head: () => ({
    meta: seo({ title: "Thank you for your interest", url: "/thanks-for-your-interest", noindex: true }),
    links: seoLinks({ url: "/thanks-for-your-interest" }),
  }),
  component: () => {
    const { cards } = Route.useLoaderData();
    return (
      <>
        <div className="mx-auto max-w-3xl px-4 py-24 text-center md:px-8 md:py-32">
          <h1 className="mb-4 text-4xl font-bold text-charcoal">Thank you for your interest.</h1>
          <p className="text-lg text-charcoal/70">
            We can't wait to share C1.ai with you. A member of our team will be in touch shortly.
          </p>
        </div>
        <LatestCardsDark
          heading="Latest on the platform"
          cards={cards}
          block="latest-cards-dark"
        />
        <CTABannerDark
          label="Join the"
          heading="Security, IT, and GRC teams saving time and improving security with C1.ai."
          button={{ text: "See their results", url: "/customers" }}
        />
      </>
    );
  },
});
